import { Component, Prop, Vue } from 'vue-property-decorator'
import VtLanguageSelector from '@/components/common/VtLanguageSelector.vue'
import LoginLayoutLogin from '@/views/auth/components/login/login-layout-login/login-layout-login.vue'
import LoginLayoutRecovery from '@/views/auth/components/login/login-layout-recovery/login-layout-recovery.vue'
import LoginLayoutRecoveryEmailSent
    from '@/views/auth/components/login/login-layout-recovery-email-sent/login-layout-recovery-email-sent.vue'
import LoginLayoutChangePassword
    from '@/views/auth/components/login/login-layout-change-password/login-layout-change-password.vue'
import {
    ChangePasswordTypeEnum,
    initialLoginLayoutState,
    LoginCardTypeEnum,
    LoginLayoutState
} from '@/views/auth/components/login/login-layout/login-layout.model'
import AnapathLoginLogo from '@/assets/images/svg/AnapathLoginLogo.vue'

@Component({
    components: {
        VtLanguageSelector,
        LoginLayoutLogin,
        LoginLayoutRecovery,
        LoginLayoutRecoveryEmailSent,
        LoginLayoutChangePassword,
        AnapathLoginLogo
    }
})
export default class LoginLayout extends Vue {
    @Prop({ type: String })
    loginCardType!: LoginCardTypeEnum

    @Prop({ type: String, default: () => ChangePasswordTypeEnum.CHANGE_PASSWORD_AFTER_FIRST_LOGIN })
    changePasswordType!: ChangePasswordTypeEnum

    get canShowLogin(): boolean {
        return this.state.card === LoginCardTypeEnum.LOGIN
    }

    get canShowRecovery(): boolean {
        return this.state.card === LoginCardTypeEnum.RECOVERY
    }
    get canShowEmailSent(): boolean {
        return this.state.card === LoginCardTypeEnum.EMAIL_SENT
    }
    get canShowChangePassword(): boolean {
        return this.state.card === LoginCardTypeEnum.CHANGE_PASSWORD
    }
    get loadingTranslations(): boolean {
        return this.state.loadingTranslations
    }

    state: LoginLayoutState
    constructor() {
        super()
        this.state = initialLoginLayoutState()
    }

    mounted(): void {
        if (this.loginCardType) {
            this.state.card = this.loginCardType
        }
    }

    showLogin(): void {
        this.state.card = LoginCardTypeEnum.LOGIN
    }
    showRecovery(): void {
        this.state.card = LoginCardTypeEnum.RECOVERY
    }
    showEmailSent(): void {
        this.state.card = LoginCardTypeEnum.EMAIL_SENT
    }
    showChangePassword(): void {
        this.state.card = LoginCardTypeEnum.CHANGE_PASSWORD
    }

    onLoadingTranslations(value: boolean): void {
        this.state.loadingTranslations = value
    }
}
